import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const RendererContentState: LoadableType<{
	contentId: string;
	isDraft: boolean;
	hasSeparator?: boolean;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RendererContentStateRendererContentState" */ '../src/RendererContentState/RendererContentState.tsx'
			)
		).RendererContentState,
});
